const init = () => {
  $(".main-table").each( (i, e) => {
    $(e).clone(true).appendTo(`#table-scroll-${i}`).addClass('clone');
  }); 

  var $manualRecommendations = $("#ITA_manualRecommendations");
  var $einsteinRecommendations = $("#product-recommendation-item");
  if ($einsteinRecommendations.length > 0) {
    $manualRecommendations.remove();
  }
  const targetNode = document.getElementById("einstein-recommendations");
  const config = { childList: true , subtree: true};

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.addedNodes.length > 0) {
        $manualRecommendations.remove();
        observer.disconnect();
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
};

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
  if (selectedValueUrl) {
      $('body').trigger('product:beforeAttributeSelect',
          { url: selectedValueUrl, container: $productContainer });

      $.ajax({
          url: selectedValueUrl,
          method: 'GET',
          success: function (data) {
              /* handleVariantResponse(data, $productContainer);
              updateOptions(data.product.optionsHtml, $productContainer);
              updateQuantities(data.product.quantities, $productContainer); */
              console.log(data.product.id,'OOOO__');
              $('.product-detail').data('pid', data.product.id);
              $('input[name="pid"]').val(data.product.id);
              $('body').trigger('product:afterAttributeSelect',
                  { data: data, container: $productContainer });
              $.spinner().stop();
          },
          error: function () {
              $.spinner().stop();
          }
      });
  }
}

module.exports = {
  init,
  selectAttribute: function () {
    $('body').on('variationSelect:change', function (e, data) {
      console.log('OOOOK', data);
      var $productContainer =  $(this).closest('.product-detail');

      attributeSelect(data.url, $productContainer);
  });

},
  methods: {},
};
